import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function SellPointBox({
  text,
  imageSrcKey,
  imageSize,
  imageClassName,
}: {
  text: string
  imageSrcKey: string
  imageSize?: { width: number; height: number }
  imageClassName?: string
}): React.ReactElement {
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.LG })
  const width = imageSize?.width || 100
  const height = imageSize?.height || 66

  return (
    <div className="flex lg:justify-center items-center gap-2 bg-purple rounded p-1 text-white lg:w-54 w-full max-w-screen-19/20 min-h-14">
      <ResponsiveImage
        className={`min-w-10 lg:min-w-20 ${imageClassName}`}
        fit="contain"
        height={isMobile ? height / 2 : height}
        srcKey={imageSrcKey}
        width={isMobile ? width / 2 : width}
      />
      <h4>{text}</h4>
    </div>
  )
}
